import { render, staticRenderFns } from "./validation_buttons_bar.vue?vue&type=template&id=08703587&"
import script from "./validation_buttons_bar.vue?vue&type=script&lang=js&"
export * from "./validation_buttons_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports